export interface CustomDataModule {
    ID: number;
    Name: string;
   }

export enum enmCSTModuleNames {
    HouseholdRegistration = 2,
    Staff = 3,
    StudentHealth = 4,
    Courses = 5,
    Behavior = 6
}